import { FeatureLogger } from "../utils/feature-logger";

const name = "ff8-product-analytics";

export const logger = new FeatureLogger(name);
